// libraries
import React, { useState } from 'react'
import { ToggleButtonGroup, ToggleButton } from '@mui/material'
import { GridOn, FormatAlignJustify } from '@mui/icons-material'

// helpers and utils
import { IBT_LIBRARY_VIEW_OPTIONS } from 'utils/constants'

export const useViewModeToggle = ({ localStorageKey }) => {
  const [viewMode, setViewMode] = useState(
    window.localStorage.getItem(localStorageKey) || IBT_LIBRARY_VIEW_OPTIONS.LIST,
  )
  return {
    viewMode,
    renderViewModeToggle: () => (
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={(event, mode) => {
          if (!mode) return
          setViewMode(mode)
          window.localStorage.setItem(localStorageKey, mode)
        }}
      >
        <ToggleButton value={IBT_LIBRARY_VIEW_OPTIONS.GRID}>
          <GridOn />
        </ToggleButton>
        <ToggleButton value={IBT_LIBRARY_VIEW_OPTIONS.LIST}>
          <FormatAlignJustify />
        </ToggleButton>
      </ToggleButtonGroup>
    ),
  }
}
